/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leveling_Perm_Read_Message_HistoryInputs */



/**
* | output |
* | --- |
* | "Read Message History" |
*
* @param {Leveling_Perm_Read_Message_HistoryInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const leveling_perm_read_message_history = /** @type {((inputs?: Leveling_Perm_Read_Message_HistoryInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leveling_Perm_Read_Message_HistoryInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Читать историю сообщений")
	return /** @type {LocalizedString} */ ("Read Message History")
});